import {Component, DestroyRef, EventEmitter, Inject, OnInit, Output} from '@angular/core';
import {FormControl, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {LocalStorageService} from 'src/app/local-storage.service';
import {BenutzerModels} from 'src/app/models/benutzer-models';
import {ServiceAppModels} from 'src/app/models/serviceapp-models';
import {DatumFormatPipe} from 'src/app/pipes/datum-format.pipe';
import {v4 as uuidv4} from 'uuid';
import {SwissSettingsService} from 'src/app/services/swiss-settings.service';
import {MessageBoxService} from 'src/app/services/message-box.service';
import {ServiceAppService} from 'src/app/services/service-app.service';
import {faSearchLocation} from '@fortawesome/free-solid-svg-icons';
import {BehaviorSubject, forkJoin, map, Observable, startWith, tap} from 'rxjs';
import {DataService} from 'src/app/time-app/services/data.service';
import {Employees} from 'src/app/time-app/models/employees-model';
import {SWISS_SERVICE_APP_DB_STORE_NAME} from '../../../../models/local-storage-names';
import {fromPromise} from 'rxjs/internal/observable/innerFrom';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {MatSelectChange} from '@angular/material/select';
import {MatAutocompleteSelectedEvent} from '@angular/material/autocomplete';
import TimeMutationAppointmentData = ServiceAppModels.TimeMutationAppointmentData;

interface Auftrag {
    value: string;
    viewValue: string;
    isPlanned: boolean;
}

interface AuftragGruppe {
    disabled?: boolean;
    name: string;
    auftraege: Auftrag[];
}

@Component({
    selector: 'app-zeit-mutation',
    templateUrl: './zeit-mutation.component.html',
    styleUrls: ['./zeit-mutation.component.scss'],
})
export class ZeitMutationComponent implements OnInit {
    faSearchLocation = faSearchLocation;

    @Output() close = new EventEmitter<any>();
    @Output() submit = new EventEmitter<any>();
    public dbMitarbeiter?: ServiceAppModels.SA_Employees[];
    public dbKostenstellen?: ServiceAppModels.SA_CostCenter[];
    public dbSpesen?: ServiceAppModels.SA_Expenses[];
    public sa_Config?: ServiceAppModels.SA_Config;
    public lblArbeitsort = 'Arbeitsort';
    public showGoodwill = false;
    public isVerrechnungsCheckboxEnabled = false;
    // Ist der folgende Wert auf false, dann muss aus der Auswahl ein Auftrag ausgewählt werden
    public useObjSearchByInput = false;
    /* Felder */
    public fldDatumKey = 'fldDatum';
    public fldMitarbeiterKey = 'fldMitarbeiter';
    public fldAuftragKey = 'fldAuftrag';
    public fldKostenstellenKey = 'fldKostenstellen';
    public fldArbeitsbezeichnungKey = 'fldArbeitsbezeichnung';
    public fldArbeitsortKey = 'fldArbeitsort';
    public fldStartzeitKey = 'fldStartzeit';
    public fldEndzeitKey = 'fldEndzeit';
    public fldAnzStundenKey = 'fldAnzStunden';
    public fldKulanzKey = 'fldKulanz';
    public fldNachtschichtKey = 'fldNachtschicht';
    public fldSpesenartKey = 'fldSpesenart';
    public fldSpesenMengeKey = 'fldSpesenMenge';
    public fldSpesenPreisKey = 'fldSpesenPreis';
    public fldSpesenEinheitKey = 'fldSpesenEinheit';
    public fldVerrechnungKey = 'fldVerrechnung';
    public fldNotizenKey = 'fldNotizen';
    public fldWorkplaceRequired = false;

    public objectSource: Array<Auftrag> = [];
    public filteredObjectSource!: Observable<Auftrag[]>;
    public formGroupZeit: UntypedFormGroup;
    public errormsg = '';
    public hasError = false;
    public fldAuftrag!: UntypedFormControl;
    public editMode = false;
    protected orderGroups: Map<string, AuftragGruppe> = new Map<string, AuftragGruppe>();
    protected isOrderPlanned: BehaviorSubject<boolean> = new BehaviorSubject(true); // default true
    protected showUnplannedOrders: BehaviorSubject<boolean> = new BehaviorSubject(false);
    protected showOrdersFromTime: BehaviorSubject<boolean> = new BehaviorSubject(false);
    private dbStammdaten?: ServiceAppModels.Stammdaten;
    private dbTermine?: ServiceAppModels.SA_Objekt[];
    private currAnwender?: BenutzerModels.Anwender;
    private oldKostenstellenID = 0;
    private timeEntry?: ServiceAppModels.SA_TimeEntry;

    constructor(private localStorageService: LocalStorageService,
                private swissSettings: SwissSettingsService,
                private _datumFormatPipe: DatumFormatPipe,
                private svcSA: ServiceAppService,
                private dataService: DataService,
                public dialogRef: MatDialogRef<ZeitMutationComponent>,
                private svcMessageBox: MessageBoxService,
                private destroyRef: DestroyRef,
                @Inject(MAT_DIALOG_DATA) public data: ServiceAppModels.SA_DataTimeMutation) {
        this.currAnwender = this.data.sA_Anwender;
        if (this.data.sA_TimeEntry) {
            this.editMode = true;
        }

        this.showGoodwill = this.data.sA_Anwender!.sA_ShowGoodwill! == 1;

        this.formGroupZeit = new UntypedFormGroup({
            fldMitarbeiter: new UntypedFormControl(),
            fldDatum: new UntypedFormControl(),
            fldAuftrag: new UntypedFormControl(),
            fldKostenstellen: new UntypedFormControl(),
            fldArbeitsbezeichnung: new UntypedFormControl(),
            fldArbeitsort: new UntypedFormControl(),
            fldStartzeit: new UntypedFormControl(),
            fldEndzeit: new UntypedFormControl(),
            fldAnzStunden: new UntypedFormControl(),
            fldKulanz: new UntypedFormControl(),
            fldNachtschicht: new UntypedFormControl(),
            fldSpesenart: new UntypedFormControl(),
            fldSpesenMenge: new UntypedFormControl(),
            fldSpesenPreis: new UntypedFormControl(),
            fldSpesenEinheit: new UntypedFormControl(),
            fldVerrechnung: new UntypedFormControl(),
            fldNotizen: new UntypedFormControl(),
        });
        this.formGroupZeit.controls[this.fldNachtschichtKey].disable();
        this.formGroupZeit.controls[this.fldAnzStundenKey].setValidators(Validators.required);
        if (this.fldWorkplaceRequired) {
            this.formGroupZeit.controls[this.fldArbeitsortKey].setValidators(Validators.required);
        }
        this.formGroupZeit.controls[this.fldArbeitsbezeichnungKey].setValidators(Validators.required);
        this.formGroupZeit.controls[this.fldDatumKey].setValidators(Validators.required);
        this.formGroupZeit.controls[this.fldMitarbeiterKey].setValidators(Validators.required);
        this.formGroupZeit.controls[this.fldAuftragKey].setValidators(Validators.required);
        this.formGroupZeit.controls[this.fldKostenstellenKey].setValidators(Validators.required);
        this.filteredObjectSource = this.formGroupZeit.get(this.fldAuftragKey)!.valueChanges.pipe(
            takeUntilDestroyed(this.destroyRef),
            startWith(''),
            map(value => this._filter(value || ''))
        );
        this.formGroupZeit.addControl('disableUnplannedOrders', new FormControl(false));
        this.formGroupZeit.controls['disableUnplannedOrders'].valueChanges.pipe(
            takeUntilDestroyed(this.destroyRef),
            tap(async (val) => {
                await this.genrateItemsForListBox(this.showOrdersFromTime.getValue(), val);
                this.formGroupZeit.get(this.fldAuftragKey)!.setValue('');
            })
        ).subscribe();
    }

    ngOnInit(): void {
        this.getDisplayExpensesInRapport();
        this.loadEmployeesFromIndexedDB().then(value => {
            if (this.currAnwender) {
                if (this.data.sA_TimeEntry) {
                    this.formGroupZeit.controls[this.fldMitarbeiterKey].setValue(this.data.sA_TimeEntry.employeeIDS);
                } else {
                    const mitarbeiter: number[] = [this.currAnwender.employeeID];
                    this.formGroupZeit.controls[this.fldMitarbeiterKey].setValue(mitarbeiter);
                }

                // Wenn der Benutzer eine Standard-Kostenstelle hat, soll diese verwendet werden
                // Ist dies nicht der Fall, dann soll die Kostenstelle aus den Serviceapp-Einstellungen im Navi genommen werden
                if (!this.data.sA_TimeEntry) {
                    if (this.currAnwender.sA_DefaultCostCenter) {
                        this.formGroupZeit.controls[this.fldKostenstellenKey].setValue(this.currAnwender.sA_DefaultCostCenter);
                        this.kostenstelleChange(this.currAnwender.sA_DefaultCostCenter);
                    } else if (this.svcSA.getSA_Config()?.standardKostenstelle) {
                        this.formGroupZeit.controls[this.fldKostenstellenKey].setValue(this.svcSA.getSA_Config()!.standardKostenstelle);
                        this.kostenstelleChange(this.svcSA.getSA_Config()!.standardKostenstelle);
                    }

                    if (this.data.sA_Termin) {
                        this.formGroupZeit.controls[this.fldDatumKey].setValue(this.data.sA_Termin.startTime);
                        if (this.data.sA_Termin.serviceID) {
                            this.formGroupZeit.controls[this.fldAuftragKey].setValue('S:' + this.data.sA_Termin.serviceID);
                        } else {
                            this.formGroupZeit.controls[this.fldAuftragKey].setValue('O:' + this.data.sA_Termin.objectID);
                        }
                    }
                }
            }
        });
        forkJoin({
            loadObjectResponse: fromPromise(this.loadObjekteFromIndexedDB()),
            showOrdersFromTime: fromPromise(this.localStorageService.get<boolean>('showOrdersFromTime', SWISS_SERVICE_APP_DB_STORE_NAME, false, false)),
        }).pipe(
            takeUntilDestroyed(this.destroyRef),
            tap(args => {
                this.showOrdersFromTime.next(args.showOrdersFromTime);
                if (args.loadObjectResponse) {
                    this.genrateItemsForListBox(args.showOrdersFromTime);
                }
            })
        ).subscribe();

        if (this.data.sA_TimeEntry) {
            if (this.swissSettings.getWebConfig().debugMode) {
                console.log('Bestehender Zeit-Eintrag: ', this.data.sA_TimeEntry);
            }

            this.loadFieldValuesFromTimeEntry();
        }

        this.changePosition();
    }

    changePosition(): void {
        this.dialogRef.updatePosition({top: '5px'});
    }

    displayFn(auftrag: Auftrag): string {
        return auftrag && auftrag.viewValue ? auftrag.viewValue : '';
    }

    async loadEmployeesFromIndexedDB(): Promise<boolean> {
        const value = await this.localStorageService.get('stammdaten', SWISS_SERVICE_APP_DB_STORE_NAME, false, null);
        if (value) {
            this.dbStammdaten = (value as ServiceAppModels.Stammdaten);
            this.dbMitarbeiter = this.dbStammdaten.sA_Employees;
            this.dbKostenstellen = this.dbStammdaten.sA_CostCenter;
            this.dbSpesen = this.dbStammdaten.sA_Expenses;

            return true;
        }
        return false;
    }

    async loadObjekteFromIndexedDB(): Promise<ServiceAppModels.SA_Objekt[]> {
        this.dbTermine = await this.localStorageService.get<ServiceAppModels.SA_Objekt[]>('objekte', SWISS_SERVICE_APP_DB_STORE_NAME, false, []);
        this.dbTermine = this.dbTermine.filter(t => t.serviceComplete === 0);

        return this.dbTermine;
    }

    async genrateItemsForListBox(showOrdersForTime = false, showOnlyPlannedServices = false): Promise<void> {
        this.useObjSearchByInput = this.svcSA.getSA_Config()?.zeiterfObjektAuswahlViaEingabe === true;
        this.objectSource = [];
        this.orderGroups = new Map<string, AuftragGruppe>();
        // Hier wird die Gruppierung der Aufträge und deren Termine vorgenommen
        if (this.dbTermine) {
            for (const termin of this.dbTermine) {
                if (showOnlyPlannedServices && !termin.serviceID) {
                    continue
                }
                const groupName = termin.objectNumber.trim() + ' ' + termin.objDescription;

                const auftrag = this.getTerminAuftrag(termin);
                this.objectSource.push(auftrag);

                const group = this.orderGroups.get(groupName);
                if (group) {
                    group.auftraege.push(auftrag);
                } else {
                    this.orderGroups.set(groupName, {disabled: false, name: groupName, auftraege: [auftrag]});
                }
            }
        }

        if (showOrdersForTime && !showOnlyPlannedServices) {
            // db termine needs to be orders from time-app
            const orders = await this.dataService.getAllOrders();
            for (const auftrag of orders) {
                const groupName = auftrag.objectNumber.trim() + ' ' + auftrag.description;
                const group = this.orderGroups.get(groupName);
                // if the order is not added yet, we add it
                if (!group) {
                    const order = {
                        viewValue: groupName,
                        value: `O:${auftrag.objectID}`,
                        isPlanned: false
                    };
                    this.objectSource.push(order);
                    this.orderGroups.set(groupName, {disabled: false, name: groupName, auftraege: [order]});
                }
            }
        }
    }

    kostenstelleChange(value: number) {
        // Wenn die Kostenstelle ändert, wird der Wert für die Arbeitsbezeichnung neu gesetzt, aber nur wenn der Text nicht schon angepasst wurde
        if (this.dbKostenstellen) {
            const neueKostenstelle = this.dbKostenstellen.filter((k) => k.costCenterID == value)[0];
            let changeArbeitsbez = false;

            if (this.oldKostenstellenID != 0) {
                // Wurde die Kostenstelle schon mal gewechselt
                const currArbeitsbez = this.formGroupZeit.controls[this.fldArbeitsbezeichnungKey].value;
                const origKostenstelleArbeitsbez = this.dbKostenstellen.filter((k) => k.costCenterID == this.oldKostenstellenID)[0].description;

                if (currArbeitsbez && origKostenstelleArbeitsbez) {
                    if (currArbeitsbez === origKostenstelleArbeitsbez) {
                        changeArbeitsbez = true;
                    }
                } else {
                    changeArbeitsbez = true;
                }
            } // Kostenstelle wurde das 1. Mal gesetzt
            else {
                changeArbeitsbez = true;
            }

            if (changeArbeitsbez) {
                const arbeitsbezeichnung = this.dbKostenstellen.filter((k) => k.costCenterID == value)[0].description;
                this.formGroupZeit.controls[this.fldArbeitsbezeichnungKey].setValue(arbeitsbezeichnung);
            }

            // Aktuelle Kostenstelle als alte Kostenstelle sichern, falls diese nochmals wechseln sollte
            this.oldKostenstellenID = value;

            this.fldWorkplaceRequired = neueKostenstelle.obligatoryWorkplace;
            // Formular-Feld muss zurückgesetzt werden, damit der * für required angezeigt oder weggenommen wird
            const fieldValue = this.formGroupZeit.controls[this.fldArbeitsortKey].value;
            this.formGroupZeit.controls[this.fldArbeitsortKey].reset();
            this.formGroupZeit.controls[this.fldArbeitsortKey].setValue(fieldValue);
        }
    }

    formatDate(datum: Date): string {
        // Formatiert das Datum in das Format "dd.MM.yyy HH.mm.ss"
        return this._datumFormatPipe.transformOnlyDate(datum);
    }

    spesenartChange(value: number) {
        // Wenn die Spesenart ändert, wird der Wert für den Preis der Spese neu gesetzt
        if (this.dbSpesen) {
            const spesenBetrag = this.dbSpesen.filter((sp) => sp.expenseID == value)[0].rate;
            this.formGroupZeit.controls[this.fldSpesenPreisKey].setValue(spesenBetrag);
            const spesen = this.dbSpesen.filter((sp) => sp.expenseID == value)[0];
            if (spesen.rate) {
                this.formGroupZeit.controls[this.fldSpesenPreisKey].setValue(spesen.rate);
            }
            if (spesen.amountOne) {
                this.formGroupZeit.controls[this.fldSpesenMengeKey].setValue(1);
            } else {
                this.formGroupZeit.controls[this.fldSpesenMengeKey].setValue(undefined);
            }
            if (spesen.unit) {
                this.formGroupZeit.controls[this.fldSpesenEinheitKey].setValue(spesen.unit);
            } else {
                this.formGroupZeit.controls[this.fldSpesenEinheitKey].setValue(undefined);
            }
            if (spesen.notChargeable) {
                this.formGroupZeit.controls[this.fldVerrechnungKey].setValue(0);
            } else {
                this.formGroupZeit.controls[this.fldVerrechnungKey].setValue(1);
            }
        }
    }

    /* Zeitberechnungs - Events */
    onTimeChange(value: any) {
        this.formGroupZeit.controls[this.fldAnzStundenKey].setValue(this.calcTimeDiff());
    }

    onNumberOfHoursChange(currValue: any) {
        if (currValue) {
            if ((currValue.toString().indexOf(':') > -1 && currValue.toString().substring(currValue.length - 1) == ':') || (currValue.toString().indexOf('.') > -1 && currValue.toString().substring(currValue.length - 1) == '.')) {
                // Wenn nach dem Doppelpunkt noch nichts eingegeben wurde --> abbrechen
                return;
            }
        }
        if (this.swissSettings.getWebConfig().debugMode) {
            console.log('NumberOfHoursChange is called');
        }
        const calcValue = this.calcTimeDiff();
        const startZeit = this.formGroupZeit.controls[this.fldStartzeitKey].value;
        if (this.swissSettings.getWebConfig().debugMode) {
            console.log('currValue / calcValue', currValue, calcValue);
        }

        if (currValue && calcValue) {
            // Alle 3 Felder abgefüllt (Startzeit, Endzeit, Anzahl Stunden gesetzt)
            if (currValue !== calcValue) {
                if (this.swissSettings.getWebConfig().debugMode) {
                    console.log('Die Werte sind unterschiedlich');
                }
                this.calcEndtime(currValue);
            }
        } else if (currValue && startZeit) {
            // Feld Startzeit und Anzahl Stunden gesetzt
            if (this.swissSettings.getWebConfig().debugMode) {
                console.log('Endzeit nicht gesetzt');
            }
            this.calcEndtime(currValue);
        }
    }

    closeDialog() {
        this.dialogRef.close(null);
    }

    save() {
        this.hasError = false;
        // Neuer Zeiteintrag wird in IndexedDB gespeichert
        if (this.swissSettings.getWebConfig().debugMode) {
            console.log('FormValues: ', this.formGroupZeit.value);
        }

        try {
            if (this.formGroupZeit.value) {
                let StartZeitPunkt: Date = this.formGroupZeit.controls[this.fldDatumKey].value;
                if (this.formGroupZeit.controls[this.fldStartzeitKey].value) {
                    // Wenn eine Startzeit definiert ist, dann wird das Datum und die gewählte Start-Zeit zu einem Datum gemacht
                    StartZeitPunkt = this.calcStartDate(StartZeitPunkt, this.formGroupZeit.controls[this.fldStartzeitKey].value);
                } else {
                    // Zeit entfernen
                    StartZeitPunkt = this._datumFormatPipe.transformOnlyDateEN(this.formGroupZeit.controls[this.fldDatumKey].value);
                }

                let EndZeitPunkt: Date;
                if (this.formGroupZeit.controls[this.fldEndzeitKey].value) {
                    // Wenn eine Endzeit definiert ist, dann wird das Datum und die gewählte Start-Zeit zu einem Datum gemacht
                    EndZeitPunkt = this.calcEndDate(StartZeitPunkt, this.formGroupZeit.controls[this.fldEndzeitKey].value);
                }

                if (this.swissSettings.getWebConfig().debugMode) {
                    console.log('StartZeitPunkt / EndZeitPunkt: ', StartZeitPunkt, EndZeitPunkt!);
                }

                let auftragID: string;
                if (this.useObjSearchByInput) {
                    auftragID = ((this.formGroupZeit.controls[this.fldAuftragKey].value) as Auftrag).value;
                } else {
                    auftragID = this.formGroupZeit.controls[this.fldAuftragKey].value;
                }
                let serviceID: string | undefined = undefined;
                let id: string;
                if (auftragID.substring(0, 2) === 'S:') {
                    serviceID = auftragID.substring(2);
                    id = serviceID;
                } else {
                    id = auftragID.substring(2);
                }

                let servicePosID: string;
                if (this.editMode) {
                    servicePosID = this.data.sA_TimeEntry!.servicePosID;
                } else {
                    servicePosID = uuidv4();
                }

                this.timeEntry = {
                    objectID: id,
                    servicePosID,
                    employeeIDS: this.formGroupZeit.controls[this.fldMitarbeiterKey].value,
                    serviceID,
                    costCenterID: this.formGroupZeit.controls[this.fldKostenstellenKey].value,
                    workPlace: this.formGroupZeit.controls[this.fldArbeitsortKey].value,
                    activityDescription: this.formGroupZeit.controls[this.fldArbeitsbezeichnungKey].value,
                    startDate: StartZeitPunkt,
                    endDate: EndZeitPunkt!,
                    duration: this.formGroupZeit.controls[this.fldAnzStundenKey].value,
                    goodWill: this.formGroupZeit.controls[this.fldKulanzKey].value,
                    nightShift: this.formGroupZeit.controls[this.fldNachtschichtKey].value,
                    expenseID: this.formGroupZeit.controls[this.fldSpesenartKey].value,
                    expenseAmount: this.formGroupZeit.controls[this.fldSpesenMengeKey].value,
                    expensePrice: this.formGroupZeit.controls[this.fldSpesenPreisKey].value,
                    expenseUnit: this.formGroupZeit.controls[this.fldSpesenEinheitKey].value,
                    expenseToCharge: this.formGroupZeit.controls[this.fldVerrechnungKey].value,
                    note: this.formGroupZeit.controls[this.fldNotizenKey].value,
                    deleted: false,
                    uploadedToServicePos: false,
                    uploadedToTimeControlEntries: false,
                };

                // Werden die erfassten Aufwände an die Zeitkontrolle übermittelt?
                if (this.svcSA.getAktuellerMitarbeiter()!.sA_Dontsendtimestotimecontrol === 0) {
                    // Die Zeiten werden an die Zeitkontrolle übermittelt
                    // Darf der Benutzer Zeiten/Aufwände in der Vergangenheit erfassen?
                    this.svcSA.getTimeEmployee().then(res => {
                        if (res) {
                            const timeEmployeeUser = res as Employees;
                            if (!timeEmployeeUser.allowTimerecordingInPast) {
                                // Nein, der Benutzer darf keine Zeiten/Aufwände in der Vergangenheit erfassen
                                // Fehlermeldung erzeugen, wenn das Datum in der Vergangenheit ist.
                                if (this.dataService.isInThePast(new Date(StartZeitPunkt))) {
                                    this.hasError = true;
                                    this.svcMessageBox.showErrorOK('MAIN_APP_DIALOG.ERROR_DIALOG.TIME_IN_PAST.text', 'MAIN_APP_DIALOG.ERROR_DIALOG.TIME_IN_PAST.title');
                                }
                            }
                        } else {
                            this.hasError = true;
                            this.svcMessageBox.showErrorOK('MAIN_APP_DIALOG.ERROR_DIALOG.TIME_NO_PERMISSIONS.text', 'MAIN_APP_DIALOG.ERROR_DIALOG.TIME_NO_PERMISSIONS.title');
                        }
                    });
                }

                if (this.svcSA.isDayClosed(this.timeEntry.startDate!)) {
                    this.hasError = true;
                    this.svcMessageBox.showErrorOK('MAIN_APP_DIALOG.ERROR_DIALOG.TIME_ALREADY_CLOSED.text', 'MAIN_APP_DIALOG.ERROR_DIALOG.TIME_ALREADY_CLOSED.title');
                }

                if (this.swissSettings.getWebConfig().debugMode) {
                    console.log('timeEntry', this.timeEntry);
                }
            }

            if (!this.hasError) {
                this.dialogRef.close(this.timeEntry);
            }
        } catch (ex) {
            // Fehlermeldung muss ausgegeben werden!!! Zeiten müssen gespeichert werden können.
            this.hasError = true;
            this.errormsg = 'Fehler bei der Speicherung der Zeit: ';
            console.error(this.errormsg, ex);
            this.svcMessageBox.showError('⚠️ ❗❗ Die Zeit konnte nicht gespeichert werden!! ❗❗ ⚠️', '!! FEHLER !!');
        }
    }

    getLocation(): void {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
                const longitude = position.coords.longitude;
                const latitude = position.coords.latitude;
                this.callApi(longitude, latitude);
            });
        } else {
            if (this.swissSettings.getWebConfig().debugMode) {
                console.log('Keine Möglichkeit, um den Standort zu ermitteln.');
            }
        }
    }

    setLocation() {
        if (navigator.geolocation) {
            console.log('Navi - Geo hier');
            navigator.geolocation.getCurrentPosition((position) => {
                const longitude = position.coords.longitude;
                const latitude = position.coords.latitude;
                console.log('long/lat', longitude, latitude);
                this.callApi(longitude, latitude);
            }, () => {
                console.log('error');
            }, {
                enableHighAccuracy: true,
            });
        }
    }

    getDisplayExpensesInRapport() {
        // Überprüft ob Spesen im Rapport angezeigt werden sollen
        if (this.currAnwender?.sA_ShowExpenseInRapport === 1) {
            if (this.swissSettings.getWebConfig().debugMode) {
                console.log('Spesen im Rapport anzeigen Anwender');
            }
            this.isVerrechnungsCheckboxEnabled = true;
        } else {
            if (this.swissSettings.getWebConfig().debugMode) {
                console.log('Spesen im Rapport nicht anzeigen');
            }
            this.sa_Config = this.svcSA.getSA_Config();
            if (this.sa_Config?.spesenInRapportAnzeigen) {
                if (this.swissSettings.getWebConfig().debugMode) {
                    console.log('Spesen im Rapport anzeigen Mandant');
                }
                this.isVerrechnungsCheckboxEnabled = true;
            } else {
                if (this.swissSettings.getWebConfig().debugMode) {
                    console.log('Spesen im Rapport nicht anzeigen Mandant');
                }
                this.isVerrechnungsCheckboxEnabled = false;
            }
        }
        return this.isVerrechnungsCheckboxEnabled;
    }

    protected onAuftragChange($event: MatAutocompleteSelectedEvent | MatSelectChange): void {
        if ($event instanceof MatAutocompleteSelectedEvent) {
            this.isOrderPlanned.next($event.option.value.isPlanned);
        }
        if ($event instanceof MatSelectChange) {
            this.isOrderPlanned.next($event.value.startsWith('S:'));
        }
    }

    private _filter(value: string): Auftrag[] {
        if (value && typeof value == 'string') {
            const filterValue = value.toLowerCase();
            return this.objectSource.filter(option => option.viewValue.toLowerCase().includes(filterValue));
        } else {
            return [];
        }
    }

    private getTerminAuftrag(termin: TimeMutationAppointmentData): Auftrag {
        let viewValue = `${termin.objectNumber.trim()} ${termin.objDescription || termin.description}`;
        let isPlanned = false;
        if (termin.serviceID && termin.startTime) {
            isPlanned = true;
            viewValue += ' ' + this.formatDate(termin.startTime);
        }

        const value = termin.serviceID ? 'S:' + termin.serviceID : 'O:' + termin.objectID;

        return {
            value, viewValue, isPlanned
        };
    }

    private calcTimeDiff(): string {
        const startZeit = this.formGroupZeit.controls[this.fldStartzeitKey].value;
        const endZeit = this.formGroupZeit.controls[this.fldEndzeitKey].value;

        if (startZeit && endZeit) {
            // Zeiten in Datum umwandeln
            const strStartDatum = '2020-01-01T' + startZeit + ':00.000';
            const startDatum: Date = new Date(strStartDatum);
            let strEndDatum = '2020-01-01T' + endZeit + ':00.000';
            let endDatum: Date = new Date(strEndDatum);

            if (this.swissSettings.getWebConfig().debugMode) {
                console.log('Start-/Enddatum: ', startDatum, endDatum);
            }
            if (startDatum > endDatum) {
                this.svcMessageBox.showWarning('Achtung Endzeit kleiner als Startzeit.<br> Die Zeit wird auf den nächsten Tag eingetragen.', 'Warnung');

                // Schichtarbeit über Nacht
                this.formGroupZeit.controls[this.fldNachtschichtKey].setValue(true);
                strEndDatum = '2020-01-02T' + endZeit + ':00.000';
                endDatum = new Date(strEndDatum);
            } else {
                // Keine Nachtschicht
                this.formGroupZeit.controls[this.fldNachtschichtKey].setValue(false);
            }

            // Unterschied in Millisekunden
            const duration = (endDatum.valueOf() - startDatum.valueOf()) / 1000 / 60;

            const hours = Math.floor(duration / 60);
            const minutes = duration % 60;
            let minutesProportion = String(Math.round((minutes / 60.0) * 100) / 100);
            minutesProportion = minutesProportion.substring(minutesProportion.indexOf('.') + 1);
            if (this.swissSettings.getWebConfig().debugMode) {
                console.log('Dauer in minTotal/h/min:', duration, hours, minutes);
            }
            if (minutes === 0) {
                return String(hours);
            } else {
                return hours + '.' + minutesProportion;
            }
        } else {
            return '';
        }
    }

    private calcEndtime(currValue: string): void {
        let stunden = 0;
        let minuten = 0;
        let strStunden: string;
        let strMinutenAnteil = '';
        let strMinuten = '';
        let doSetEndDatum = false;

        if (currValue.indexOf('.') > -1) {
            // Stunden und Minutenangaben
            strStunden = currValue.substring(0, currValue.indexOf('.'));
            strMinutenAnteil = '0.' + currValue.substring(currValue.indexOf('.') + 1);
            if (this.swissSettings.getWebConfig().debugMode) {
                console.log('stunden / minutenanteil', strStunden, strMinuten);
            }
        } else {
            // Es wurden nur Stunden eingegeben
            strStunden = currValue;
        }

        const startZeit = this.formGroupZeit.controls[this.fldStartzeitKey].value;
        const strStartDatum = '2020-01-01T' + startZeit + ':00.000';
        const startDatum: Date = new Date(strStartDatum);
        const endDatum: Date = startDatum;

        if (strMinutenAnteil) {
            // Anteil in Minuten umrechnen => Bsp. 0.75 = 45 Minuten
            strMinuten = String(Number(strMinutenAnteil) * 60.0);
            if (this.swissSettings.getWebConfig().debugMode) {
                console.log('strMinutenAnteil / strMinuten', strMinutenAnteil, strMinuten);
            }
        }

        if (strStunden && strMinuten) {
            stunden = Number(strStunden);
            minuten = Number(strMinuten);
            if (stunden && minuten) {
                endDatum.setTime(startDatum.getTime() + stunden * 60 * 60 * 1000 + minuten * 60 * 1000);
                if (this.swissSettings.getWebConfig().debugMode) {
                    console.log('Enddatum mit Stunden/Minuten berechnet:', endDatum);
                }
                doSetEndDatum = true;
            }
        } else if (strStunden) {
            stunden = Number(strStunden);
            if (stunden) {
                endDatum.setTime(startDatum.getTime() + stunden * 60 * 60 * 1000);
                doSetEndDatum = true;
                if (this.swissSettings.getWebConfig().debugMode) {
                    console.log('Enddatum mit Stunden berechnet:', endDatum);
                }
            }
        }

        if (doSetEndDatum) {
            // Endzeit im Form darf angepasst werden
            let strEndDatumZeit: string;
            let strHours: string = String(endDatum.getHours());
            let strMinutes: string = String(endDatum.getMinutes());
            if (strHours.length === 1) {
                strHours = '0' + strHours;
            }
            if (strMinutes.length === 1) {
                strMinutes = '0' + strMinutes;
            }

            strEndDatumZeit = strHours + ':' + strMinutes;
            this.formGroupZeit.controls[this.fldEndzeitKey].setValue(strEndDatumZeit);
        }
    }

    private calcStartDate(startZeitpunkt: Date, addZeit: string): Date {
        // Formatiert das Datum in das Format "yyyy-MM-dd"
        const strDatum = this._datumFormatPipe.transformOnlyDateEN(startZeitpunkt);
        const strStartDatum = strDatum + 'T' + addZeit + ':00.000';
        const startDatum: Date = new Date(strStartDatum);
        if (this.swissSettings.getWebConfig().debugMode) {
            console.log('In CalcStartDate', startDatum);
        }
        return startDatum;
    }

    private calcEndDate(startZeitpunkt: Date, addZeit: string): Date {
        const strDatum = this._datumFormatPipe.transformOnlyDateEN(startZeitpunkt);
        const strEndDatum = strDatum + 'T' + addZeit + ':00.000';
        const endDatum: Date = new Date(strEndDatum);
        if (startZeitpunkt > endDatum) {
            endDatum.setDate(endDatum.getDate() + 1);
        }
        return endDatum;
    }

    private loadFieldValuesFromTimeEntry(): void {
        if (this.data.sA_TimeEntry) {
            this.formGroupZeit.controls[this.fldDatumKey].setValue(this.data.sA_TimeEntry.startDate);
            this.formGroupZeit.controls[this.fldMitarbeiterKey].setValue(this.data.sA_TimeEntry.employeeIDS);
            if (this.data.sA_TimeEntry.serviceID) {
                this.formGroupZeit.controls[this.fldAuftragKey].setValue('S:' + this.data.sA_TimeEntry.serviceID);
            } else {
                this.formGroupZeit.controls[this.fldAuftragKey].setValue('O:' + this.data.sA_TimeEntry.objectID);
            }

            this.formGroupZeit.controls[this.fldKostenstellenKey].setValue(this.data.sA_TimeEntry.costCenterID);
            this.formGroupZeit.controls[this.fldArbeitsbezeichnungKey].setValue(this.data.sA_TimeEntry.activityDescription);
            this.formGroupZeit.controls[this.fldArbeitsortKey].setValue(this.data.sA_TimeEntry.workPlace);
            if (this.data.sA_TimeEntry.startDate) {
                if (String(this.data.sA_TimeEntry.startDate).length > 10) {
                    // Nur wenn ein Datum mit Zeit gespeichert ist
                    if (this.swissSettings.getWebConfig().debugMode) {
                        console.log('StartDatum: ', String(this.data.sA_TimeEntry.startDate));
                    }
                    const startzeit = this._datumFormatPipe.transformOnlyTime(this.data.sA_TimeEntry.startDate);
                    this.formGroupZeit.controls[this.fldStartzeitKey].setValue(startzeit);
                }
            }
            if (this.data.sA_TimeEntry.endDate) {
                const endzeit = this._datumFormatPipe.transformOnlyTime(this.data.sA_TimeEntry.endDate);
                this.formGroupZeit.controls[this.fldEndzeitKey].setValue(endzeit);
            }
            this.formGroupZeit.controls[this.fldAnzStundenKey].setValue(this.data.sA_TimeEntry.duration);
            if (this.data.sA_TimeEntry.goodWill) {
                this.formGroupZeit.controls[this.fldKulanzKey].setValue(this.data.sA_TimeEntry.goodWill);
            }
            if (this.data.sA_TimeEntry.nightShift) {
                this.formGroupZeit.controls[this.fldNachtschichtKey].setValue(this.data.sA_TimeEntry.nightShift);
            }
            if (this.data.sA_TimeEntry.expenseID) {
                this.formGroupZeit.controls[this.fldSpesenartKey].setValue(this.data.sA_TimeEntry.expenseID);
            }
            if (this.data.sA_TimeEntry.expenseAmount) {
                this.formGroupZeit.controls[this.fldSpesenMengeKey].setValue(this.data.sA_TimeEntry.expenseAmount);
            }
            if (this.data.sA_TimeEntry.expensePrice) {
                this.formGroupZeit.controls[this.fldSpesenPreisKey].setValue(this.data.sA_TimeEntry.expensePrice);
            }
            if (this.data.sA_TimeEntry.expenseUnit) {
                this.formGroupZeit.controls[this.fldSpesenEinheitKey].setValue(this.data.sA_TimeEntry.expenseUnit);
            }
            if (this.data.sA_TimeEntry.expenseToCharge) {
                this.formGroupZeit.controls[this.fldVerrechnungKey].setValue(this.data.sA_TimeEntry.expenseToCharge);
            }
            if (this.data.sA_TimeEntry.note) {
                this.formGroupZeit.controls[this.fldNotizenKey].setValue(this.data.sA_TimeEntry.note);
            }
        }
    }

    private callApi(Longitude: number, Latitude: number): void {
        this.svcSA.reverseGeocoding(Latitude, Longitude).subscribe({
            next: (res: any) => {
                if (res.address.city) {
                    this.formGroupZeit.controls.fldArbeitsort.setValue(res.address.city);
                } else if (res.address.town) {
                    this.formGroupZeit.controls.fldArbeitsort.setValue(res.address.town);
                } else if (res.address.village) {
                    this.formGroupZeit.controls.fldArbeitsort.setValue(res.address.village);
                }
            },
        });
    }
}
